import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

// src/classnames.ts
function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export { cn };
//# sourceMappingURL=classnames.js.map
//# sourceMappingURL=classnames.js.map